(() => {
  const ACTIVE_CLASS = 'is-active';
  const OPEN_CLASS = 'is-open';

  const clearActive = (root) => {
    const tabs = root.querySelectorAll('[data-stones-mega-tab]');
    const panes = root.querySelectorAll('[data-stones-mega-pane]');

    tabs.forEach((tab) => {
      tab.classList.remove(ACTIVE_CLASS);
      tab.setAttribute('aria-selected', 'false');
    });

    panes.forEach((pane) => {
      pane.classList.remove(ACTIVE_CLASS);
    });

    root.classList.remove(OPEN_CLASS);
  };

  const setActive = (root, index) => {
    const tabs = root.querySelectorAll('[data-stones-mega-tab]');
    const panes = root.querySelectorAll('[data-stones-mega-pane]');

    const activeTab = root.querySelector(`[data-stones-mega-tab="${String(index)}"]`);
    const hasChildren = activeTab?.getAttribute('data-stones-mega-has-children') === 'true';

    if (!hasChildren) {
      clearActive(root);
      return;
    }

    root.classList.add(OPEN_CLASS);

    tabs.forEach((tab) => {
      const isActive = tab.getAttribute('data-stones-mega-tab') === String(index);
      tab.classList.toggle(ACTIVE_CLASS, isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    panes.forEach((pane) => {
      const isActive = pane.getAttribute('data-stones-mega-pane') === String(index);
      pane.classList.toggle(ACTIVE_CLASS, isActive);
    });
  };

  const init = (root) => {
    if (!(root instanceof HTMLElement)) return;
    if (root.dataset.stonesMegaInitialized === 'true') return;
    root.dataset.stonesMegaInitialized = 'true';

    clearActive(root);

    root.addEventListener('mouseover', (event) => {
      const target = event.target instanceof Element ? event.target.closest('[data-stones-mega-tab]') : null;
      if (!target) return;
      setActive(root, target.getAttribute('data-stones-mega-tab'));
    });

    root.addEventListener('focusin', (event) => {
      const target = event.target instanceof Element ? event.target.closest('[data-stones-mega-tab]') : null;
      if (!target) return;
      setActive(root, target.getAttribute('data-stones-mega-tab'));
    });

    root.addEventListener('mouseleave', () => {
      clearActive(root);
    });
  };

  const boot = () => {
    document.querySelectorAll('[data-stones-mega]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
